import React, { useEffect, useRef } from "react";
import { ErrorBanner, FONT, Spinner, fieldHeight, h2Style, primaryButton, rise, subStyle } from "./authFlowUi";

const StepVerify = ({ mobile, short, roomy, first, email, otp, onOtpChange, error, errorCount, loading, secs, onResend, onBack, onVerify }) => {
  const refs = useRef([]);
  const H = fieldHeight(mobile, short, roomy);
  const code = otp.join("");

  useEffect(() => {
    refs.current[0]?.focus();
  }, [errorCount]);

  const setDigit = (i, raw) => {
    const digits = raw.replace(/\D/g, "");
    if (digits.length >= 6) {
      const full = digits.slice(-6);
      onOtpChange(full.split(""));
      refs.current[5]?.focus();
      onVerify(full);
      return;
    }
    const digit = digits.slice(-1);
    const next = otp.slice();
    next[i] = digit;
    onOtpChange(next);
    if (digit && i < 5) refs.current[i + 1]?.focus();
    if (digit && next.join("").length === 6) onVerify(next.join(""));
  };

  const onKeyDown = (i, e) => {
    if (e.key === "Backspace" && !otp[i] && i > 0) refs.current[i - 1]?.focus();
    if (e.key === "Enter" && code.length === 6 && !loading) onVerify(code);
  };

  const onPaste = (e) => {
    const digits = (e.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, 6);
    if (digits.length === 6) {
      e.preventDefault();
      onOtpChange(digits.split(""));
      onVerify(digits);
    }
  };

  const cellStyle = (ch) => ({
    flex: 1,
    minWidth: 0,
    height: short ? 54 : 60,
    textAlign: "center",
    font: `600 22px ${FONT}`,
    color: "#171717",
    borderRadius: 14,
    background: "#fff",
    outline: "none",
    boxSizing: "border-box",
    transition: "all .18s ease",
    caretColor: "#8B55DD",
    ...(error
      ? { border: "1.5px solid #E0476B", boxShadow: "0 0 0 3px rgba(224,71,107,.14)" }
      : ch
      ? { border: "1.5px solid #8B55DD", boxShadow: "0 0 0 3px rgba(139,85,221,.14)", transform: "translateY(-2px)" }
      : { border: "1.5px solid rgba(0,0,0,.10)" }),
  });

  return (
    <div style={rise}>
      <button
        type="button"
        className="ds-pill-btn"
        onClick={onBack}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 7,
          width: "fit-content",
          whiteSpace: "nowrap",
          padding: "7px 14px",
          marginBottom: 18,
          borderRadius: 999,
          border: "1px solid rgba(0,0,0,.10)",
          background: "rgba(255,255,255,.8)",
          cursor: "pointer",
        }}
      >
        <img src="/back.svg" alt="" style={{ width: 14, height: 14 }} />
        <span style={{ fontSize: 13, fontWeight: 500, color: "#52525B" }}>Change details</span>
      </button>

      <h2 style={{ ...h2Style, letterSpacing: 0, fontSize: roomy ? 30 : 26 }}>{first ? `Check your inbox, ${first}` : "Check your inbox"}</h2>
      <p style={subStyle("8px 0 24px")}>
        We sent a 6-digit code to <span style={{ fontWeight: 600, color: "#171717" }}>{email}</span>.
      </p>

      <div
        key={errorCount}
        style={{
          display: "flex",
          gap: 8,
          ...(error ? { animation: "dsShake 420ms cubic-bezier(.36,.07,.19,.97) both" } : {}),
        }}
      >
        {otp.map((ch, i) => (
          <input
            key={i}
            ref={(el) => {
              refs.current[i] = el;
            }}
            type="text"
            inputMode="numeric"
            autoComplete={i === 0 ? "one-time-code" : "off"}
            aria-label={`Digit ${i + 1}`}
            value={ch}
            onChange={(e) => setDigit(i, e.target.value)}
            onKeyDown={(e) => onKeyDown(i, e)}
            onPaste={onPaste}
            style={cellStyle(ch)}
          />
        ))}
      </div>

      {error && <ErrorBanner style={{ marginTop: 14 }}>{error}</ErrorBanner>}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 18 }}>
        <button
          type="button"
          onClick={secs > 0 ? undefined : onResend}
          style={{
            whiteSpace: "nowrap",
            padding: 0,
            border: "none",
            background: "none",
            ...(secs > 0
              ? { font: `500 13px ${FONT}`, color: "#8B7D91", cursor: "default" }
              : { font: `600 13px ${FONT}`, color: "#8B55DD", cursor: "pointer", textDecoration: "underline" }),
          }}
        >
          {secs > 0 ? `Resend code in 00:${String(secs).padStart(2, "0")}` : "Didn’t get it? Resend code"}
        </button>
        <span style={{ font: `500 12px ${FONT}`, color: "#C0B2C6", whiteSpace: "nowrap" }}>Paste works too</span>
      </div>

      <div style={{ marginTop: 22 }}>
        <button
          type="button"
          onClick={() => code.length === 6 && !loading && onVerify(code)}
          style={primaryButton(code.length === 6 && !loading, H)}
        >
          {loading && <Spinner />}
          {loading ? "Checking…" : "Confirm code"}
        </button>
      </div>
    </div>
  );
};

export default StepVerify;
